// db.js - Configuración de Dexie.js para aplicación offline-first
import Dexie from 'dexie';

export const db = new Dexie('JNC_AQ_Database');

db.version(1).stores({
    GES_Analisis: '++Id, id,nombre, tipo, deleted',
    //GES_Archivos: '++id, Nombre, AddDate, ModDate, deleted',
    GES_Clientes: '++Id, Codigo, IdSector, IdFormaPago, deleted',
    //GES_ClientesContactos: '++Id, Nombre, AddDate, ModDate, deleted',
    GES_ComentariosElementos: '++Id, idElemento, idTarea, fecha, idAnalisis, deleted',
    GES_ComentariosPrivados: '++Id, fecha, idAnalisis, deleted',
    GES_Conf_Analisis_NivelesPlantasCliente: '++Id, Id_NivelesPlanta, Id_Analisis, deleted',
    GES_Conf_NivelesPlantasCliente: '++Id, codigoCliente, oferta, Id_Planta, nivel, Id_Elemento, visible, deleted',
    GES_Conf_PlantasCliente: '++Id, codigoCliente, nombreCliente, oferta, numNiveles, diagrama, [codigoCliente+oferta], deleted',
    //GES_Consumos: '++Id, Fecha, deleted',
    //GES_Elementos: '++Id, Nombre, deleted',
    GES_ElementosPlanta: '++Id, id,  Nombre, numero, descripcion, verInsp, deleted',
    //GES_Entregas: '++Id, Fecha, AddDate, ModDate, deleted',
    //GES_Files: '++Id, IdTareaAnalisis, IdComentario, deleted',
    //GES_HistorialCorreosEnviados: '++Id, IdElemento, Fecha, AddDate, ModDate, deleted',
    //GES_ModoEnvio: '++Id, Nombre, AddDate, ModDate, deleted',
    GES_ObservacionesElementos: '++Id, idElemento, idTarea , fecha',
    GES_OfertasClientes: '++Id, AddDate, ModDate, deleted',
    //GES_OfertasContactos: '++Id, IdOferta, IdContacto, deleted',
    //GES_OfertasProductos: '++Id, IdOferta, IdProducto, deleted',
    GES_ParametrosAnalisisPlanta: 'id, fecha, codigoCliente, oferta, elemento, analisis, deleted',
    GES_ParametrosElementoPlantaCliente: 'id, parametro, codigoCliente, oferta, id_Elemento, id_Analisis, esplantilla, limInf, limSup, unidades, activo, AddDate, ModDate, deleted',
    //GES_ParametrosElementoPlantaCliente_OLD: '++Id, AddDate, ModDate, deleted',
    //GES_Productos: '++Id, AddDate, ModDate, deleted',
    //GES_Proveedores: '++Id, Codigo, Nombre, AddDate, ModDate, deleted',
    //GES_TareaArchivos: '++Id, IdTarea, IdFile, deleted',
    GES_Tareas: '++Id, Fecha, deleted',
    GES_ValorParametros: '++Id, codigoCliente, oferta, id_Elemento, id_Analisis, id_Operario, parametro, fecha, valor, unidad, metodo, puntoMuestreo, AddDate, ModDate, deleted',
    //LST_Comarcas: '++Id, AddDate, ModDate, deleted',
    LST_Parametros: '++Id, nombre, unidad, esCalculado, parametrosCalculo, idParametroCalculado, deleted',
    //LST_Poblaciones: '++Id, AddDate, ModDate, deleted',
    //LST_Provincias: '++Id, Codigo, AddDate, ModDate, deleted',
    LST_Unidades: '++Id, Nombre, deleted',
    //SYS_Correos: '++Id, AddDate, ModDate, deleted',
    SYS_Perfiles: '++Id, Nombre, deleted',
    SYS_Usuarios: '++Id, Nombre, Activo, IdCliente, IdPerfil, deleted',
    PendingSync: '++id, type, timestamp'
});
